<template>
  <v-container fluid grid-list-sm>
    <h3 class="headline grey--text text--darken-1 pt-3 pb-3">
      <span v-if="isList">Tags</span>
      <router-link
        v-else
        to="/tag"
        class="grey--text text--darken-2 no-decoration">
        {{ $store.getters.getLangKey('tagArchives') }}: "{{ this.id }}" ({{ pages.length }} posts)
      </router-link>
    </h3>
    <v-layout>
      <v-flex row wrap>
        <vue-adsense ad-slot="2619967717" ad-format="auto" />
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="isList">
      <v-flex xs12 sm3 lg3 v-for="(tag, index) in tags" :key="index">
        <v-card>
          <v-card-actions>
            <v-btn
              router
              block
              raised
              ripple
              :style="{opacity: setOpacity(tag.post_count)}"
              :color="baseColor"
              :to="`/tag/${tag.slug}`"
              :title="tag.slug"
              class="opaque-btn cat-tag-label-btn"
              v-html="`${tag.slug} (${tag.post_count})`" />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else v-for="(page, index) in pages" :key="index">
      <v-flex>
        <h4 class="subheading pt-1 pb-1">
          <router-link class="grey--text text--darken-2" :to="createPostUrl(page.date, page.slug)" v-html="page.title_plain" />
        </h4>
        <p html="grey--text text--darken-2" v-html="sanitize(page.excerpt)" />
        <post-details :page="page" />
      </v-flex>
    </v-layout>
  </v-container>
  </v-container>
</template>
<script>
  import TagsList from '../components/TagsList.vue'
  import CategoriesList from '../components/CategoriesList.vue'
  import PostDetails from '../components/PostDetails.vue'
  import Mixins from '../helpers/Mixins'
  import Filters from '../helpers/Filters'

  export default {
    name: 'TagPage',
    mixins: [
      Mixins
    ],
    components: {
      TagsList,
      CategoriesList,
      PostDetails
    },
    data () {
      return {
        tags: this.$store.getters.tags.sort(function (a, b) {
          return b.post_count - a.post_count
        }),
        baseColor: this.$store.state.baseColor,
        isList: true,
        pages: []
      }
    },
    watch: {
      '$route.params.id': function () {
        this.getId()
      }
    },
    mounted () {
      this.getId()
    },
    methods: {
      getId () {
        this.id = this.$route.params.id
        const store = this.$store
        if (!this.id) {
          // list all tags
          this.isList = true
          this.setTitle(store.getters.getLangKey('tags'))
        } else {
          const getters = store.getters
          const base = getters.apiProxyUrl
          const resource = 'get_tag_posts'
          const tagSlug = this.id
          const url = `${base}?resource=${resource}&tag_slug=${tagSlug}`
          this.isList = false
          const ajax = store.state.events.ajax
          const cachedTag = getters.tag(this.id)
          if (cachedTag) {
            this.pages = cachedTag
            this.setTitle(this.id)
            return
          }
          this.$root.$emit(ajax, true)
          this.$http(url).then(response => {
            response = response.data
            if (!response) {
              this.to404()
              return
            }
            this.pages = response.posts
            this.$store.commit('setTag', {
              slug: this.id,
              pages: this.pages
            })
            this.setTitle(response.tag.title)
            this.$root.$emit(ajax, false)
          })
        }
      },
      /**
       * @using ../../filters
       */
      formatDate () {
        return Filters.formatDate()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/TagPage.vue